module.exports = __webpack_public_path__ + "img/register_icon__personal.f1570174.svg";